<style scoped lang="scss">
    .spinner-backdrop {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .3);
        z-index: 999999999999;
    }

    .spinner-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>

<template>
    <span v-if="isActive" v-bind:class="{'spinner-backdrop': inline === false}">
        <span v-bind:class="{'spinner-content': inline === false}" >
            <span class="spinner-border text-primary" v-bind:style="{'width': size + 'px', 'height': size + 'px'}"></span>
        </span>
    </span>
</template>

<script>
    export default {

        data() {
            return {
                isActive: false,
                promises: [],
            };
        },

        props: {
            initStart: {
                type: Boolean,
                default: false
            },
            inline: {
                type: Boolean,
                default: false
            },
            size: {
                type: Number,
                default: 32
            },
        },

        mounted() {
            if (this.initStart === true) {
                this.start();
            }

            this.$emit('initized', this);
        },

        methods: {

            check() {
                Promise.all(this.promises).finally(() => this.stop());
            },

            start() {
                this.isActive = true;
            },

            stop() {
                this.isActive = false;
            },

            spin(promise) {
                this.start();

                promise.finally(() => this.check());

                this.promises.push(promise);

                return promise;
            },

        },

    }
</script>
